import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  applicantData: {},
  applicantPic: null,
  moodleInstanceList: [],
  roundDetails: [],
  modalRoundData: null,
  lastRoundResult: null,
  claimedByDetails: null,
  usersDetails: [],
  applicantID: null,
  commentList: [],
  jobProfiles: [],
  forms: {},
  followUpDetails: null,
};

/**
 * @memberOf module:ApplicantProfile
 * @namespace store
 * @description local store for applicant profile
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
